import {
  enUS, fr, type Locale,
} from 'date-fns/locale';
import i18n from '@/lib/i18n/i18n';

const localeMap: Record<string, Locale> = {
  en: enUS,
  'en-US': enUS,
  fr,
  // add more as we need later
};

function getDateFnsLocale(): Locale {
  const lang = i18n.resolvedLanguage || i18n.language || 'en';

  // Try full code first: "en-US"
  if (localeMap[lang]) return localeMap[lang];

  // Then try base language: "en" from "en-GB"
  const base = lang.split('-')[0];
  if (localeMap[base]) return localeMap[base];

  // Fallback
  return enUS;
}
// eslint-disable-next-line import/prefer-default-export
export { getDateFnsLocale };
